<template>
  <section class="dp-layout leave-config-page">
    <!-- 左侧部门树 -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
    </section>

    <!-- 右侧配置内容 -->
    <section class="dp-right">
      <div class="config-panel">
        <!-- 列表内容 -->
        <div v-if="departmentId > 0" class="config-content">
          <!-- 请假审批流程：与德育配置页一致的部门级开关，持久化到 SchoolConfig -->
          <el-card class="config-card settings-card" shadow="never" v-loading="leaveApprovalLoading">
            <div slot="header" class="card-header">
              <span class="title">请假审批流程</span>
              <el-button size="mini" type="primary" icon="el-icon-check" :loading="leaveApprovalSaving"
                @click="saveLeaveApprovalConfig">
                保存配置
              </el-button>
            </div>
            <div class="setting-grid setting-grid--single">
              <div class="setting-tile setting-tile--wide">
                <div class="tile-label"><i class="el-icon-s-check"></i> 自动完成重叠节点</div>
                <div class="tile-control">
                  <el-switch v-model="leaveApprovalConfig.autoCompleteOnApproverOverlap" active-text="开启"
                    inactive-text="关闭"></el-switch>
                </div>
                <p class="tile-tip">开启后，若发起人或当前审批人属于下一节点审批人之一，由系统自动完成相应审批。</p>
              </div>
              <div class="setting-tile setting-tile--wide">
                <div class="tile-label"><i class="el-icon-food"></i> 请假页显示退餐</div>
                <div class="tile-control">
                  <el-switch v-model="leaveApprovalConfig.showMealRefund" active-text="开启"
                    inactive-text="关闭"></el-switch>
                </div>
                <p class="tile-tip">开启后，手机端请假、代申请可按天勾选退餐（仅勾选「就餐时间管理」中标记可退餐的餐次）；审批通过后计入订餐管理下的请假退餐统计。仅做登记，不联动订餐退订。</p>
              </div>
            </div>
          </el-card>

          <el-card class="config-card table-card" shadow="never" v-loading="loading">
            <div slot="header" class="card-header table-header">
              <span class="title">统计权限分组</span>
              <div class="header-actions">
                <el-input v-model="filters.name" placeholder="快速定位分组..." size="mini" clearable
                  prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="getList">
                </el-input>
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleAdd">新增统计分组</el-button>
              </div>
            </div>

                        <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
                        <div class="tbl-scroll-host">
                        <el-table height="100%" :data="list" border stripe size="small" style="width: 100%">
              <el-table-column type="index" width="50" align="center" label="#"></el-table-column>
              <el-table-column prop="Name" label="分组名称" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="TeacherNames" label="包含教师" min-width="150">
                <template slot-scope="scope">
                  <el-button
                    v-if="teacherNameList(scope.row).length"
                    type="text"
                    size="small"
                    icon="el-icon-user"
                    class="kq-dept-link-btn"
                    @click.stop="openTeacherViewDialog(scope.row)">
                    已选 {{ teacherNameList(scope.row).length }} 名教师
                  </el-button>
                  <span v-else class="empty-inline">-</span>
                </template>
              </el-table-column>
              <el-table-column prop="DepartmentNames" label="可见范围" min-width="240">
                <template slot-scope="scope">
                  <span v-if="!deptNameList(scope.row).length" class="empty-inline">-</span>
                  <div v-else class="luxury-preview" @click="handleViewDepts(scope.row)">
                    <div class="tags-overflow-mask">
                      <span v-for="(name, index) in deptNameList(scope.row).slice(0, 3)" :key="index" class="glass-tag">
                        {{ name }}
                      </span>
                    </div>
                    <div v-if="deptNameList(scope.row).length > 3" class="luxury-badge">
                      +{{ deptNameList(scope.row).length - 3 }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="Remark" label="备注" show-overflow-tooltip></el-table-column>
              <el-table-column prop="CreateTime" label="创建时间" width="160" align="center">
              </el-table-column>
              <el-table-column label="操作" width="160" align="center" header-align="center" 
                class-name="leave-table-action-col">
                <template slot-scope="scope">
                  <div class="table-actions">
                    <el-button type="text" size="small" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" icon="el-icon-delete" class="danger-text-btn"
                      @click="handleDelete(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
                        </div>

            <!-- 分页 -->
            <div class="pagination-container">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-card>
        </div>

        <!-- 未选择部门提示 -->
        <div v-else class="no-department-tip">
          <div style="text-align: center">
            <i class="el-icon-school" style="font-size: 64px; color: #ebeef5; margin-bottom: 20px"></i>
            <p style="font-size: 14px; color: #909399;">请在左侧选择一个部门以管理权限分组</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" append-to-body
      :close-on-click-modal="false">
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="100px" size="small">
        <el-form-item label="分组名称" prop="Name">
          <el-input v-model="editForm.Name" placeholder="如：教导处统计组"></el-input>
        </el-form-item>
        <el-form-item label="包含教师" prop="TeacherMasterIds">
          <!-- 人数不多时完整展示已选教师，不收成 +N。最后更新：2026-10-30 -->
          <el-select v-model="teacherIds" multiple filterable placeholder="请选择可见统计的教师"
            style="width: 100%" class="stat-teacher-select">
            <el-option v-for="item in teacherOptions" :key="item.Id" :label="item.TeacherName"
              :value="item.Id.toString()">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计范围" prop="DepartmentIds">
          <el-cascader v-model="deptIds" :options="deptTreeOptions"
            :props="{ multiple: true, emitPath: false, value: 'value', label: 'label', children: 'children' }"
            placeholder="请选择统计包含的班级/部门" clearable collapse-tags style="width: 100%"></el-cascader>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="editForm.Remark" :rows="3" placeholder="可选填"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 可见范围详情弹窗 (Luxury 重构版) -->
    <el-dialog :visible.sync="viewVisible" width="680px" append-to-body custom-class="luxury-dialog">
      <div slot="title" class="luxury-header">
        <div class="header-icon"><i class="el-icon-collection"></i></div>
        <div class="header-text">
          <span class="prefix">权限详情</span>
          <span class="divider">/</span>
          <span class="group-name">{{ viewRow.Name }}</span>
        </div>
      </div>
      <div class="luxury-body">
        <div class="luxury-tags-wall">
          <span v-for="(name, index) in (viewRow.DepartmentNames || '').split('、').filter(n => n)" :key="index"
            class="refined-tag">
            {{ name }}
          </span>
        </div>
        <div v-if="!(viewRow.DepartmentNames || '').split('、').filter(n => n).length" class="empty-state-mini">
          暂无可见部门
        </div>
      </div>
    </el-dialog>

    <!-- 包含教师详情弹窗。最后更新：2026-09-08 -->
    <el-dialog :title="teacherViewDialog.title" :visible.sync="teacherViewDialog.visible" width="600px"
      :close-on-click-modal="false" append-to-body custom-class="kq-dept-view-dialog">
      <div class="kq-view-head">
        <div class="kq-view-head-item">
          <span class="label">分组：</span>
          <span class="val">{{ teacherViewDialog.groupName || '-' }}</span>
        </div>
        <div class="kq-view-head-item">
          <span class="label">所属机构：</span>
          <span class="val">{{ departmentName || '-' }}</span>
        </div>
        <div class="kq-view-head-item">
          <span class="label">总数：</span>
          <span class="val count-badge">{{ teacherViewDialog.teachers ? teacherViewDialog.teachers.length : 0 }} 名教师</span>
        </div>
      </div>

      <div class="kq-view-toolbar">
        <el-input v-model="teacherViewDialog.filterKey" size="small" placeholder="搜索教师姓名..." prefix-icon="el-icon-search"
          clearable class="kq-view-search-input" />
        <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllTeacherNames">
          复制全部姓名
        </el-button>
      </div>

      <div class="kq-view-table-wrap">
        <el-table :data="filteredViewTeachers" size="small" max-height="320" border stripe class="kq-view-table">
          <el-table-column type="index" label="序号" width="70" align="center" />
          <el-table-column prop="name" label="教师姓名" min-width="240">
            <template slot-scope="scope">
              <span class="dept-text">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySingleTeacherName(scope.row.name)">复制</el-button>
            </template>
          </el-table-column>
          <div slot="empty" class="kq-view-empty">暂无匹配的教师</div>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="teacherViewDialog.visible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getLeaveStatPermissionGroupList, saveLeaveStatPermissionGroup, deleteLeaveStatPermissionGroup } from '../../api/modules/misc';
import { getSubDepartmentTree, getLeaveApprovalConfig, setLeaveApprovalConfig } from '../../api/modules/department';
import { getTeacherMasterList } from '../../api/modules/personnel';
import DepartmentPane from "../../components/DepartmentPane";
import util from "../../../util/date";

export default {
  components: { DepartmentPane },
  filters: {
    formatDate(time) {
      if (!time) return "";
      return util.formatDate.format(new Date(time), "yyyy-MM-dd HH:mm");
    },
    formatDepts(val) {
      if (!val) return "-";
      const list = val.split("、").filter((n) => n);
      if (list.length <= 3) return val;
      return list.slice(0, 3).join("、") + "...";
    },
  },
  data() {
    return {
      filters: {
        name: "",
      },
      departmentId: 0,
      departmentName: "",
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      loading: false,
      saving: false,

      // 弹窗相关
      dialogVisible: false,
      dialogTitle: "新增统计权限组",
      editForm: {
        Id: 0,
        Name: "",
        DepartmentId: 0,
        Remark: "",
        DepartmentIds: "",
        TeacherMasterIds: "",
      },
      teacherIds: [], // 临时存储选中的教师ID数组
      deptIds: [], // 临时存储选中的部门ID数组
      editRules: {
        Name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
      },

      // 选项数据
      teacherOptions: [],
      deptTreeOptions: [],

      // 详情查看
      viewVisible: false,
      viewRow: {},

      // 请假审批流程配置（部门级）
      leaveApprovalLoading: false,
      leaveApprovalSaving: false,
      leaveApprovalConfig: {
        autoCompleteOnApproverOverlap: false,
        showMealRefund: false,
      },
      // 包含教师详情查看。最后更新：2026-09-08
      teacherViewDialog: {
        visible: false,
        title: '包含教师',
        groupName: '',
        teachers: [],
        filterKey: '',
      },
    };
  },
  computed: {
    // 弹窗过滤后的教师列表。最后更新：2026-09-08
    filteredViewTeachers() {
      const list = this.teacherViewDialog.teachers || [];
      const key = (this.teacherViewDialog.filterKey || '').trim().toLowerCase();
      if (!key) {
        return list.map(name => ({ name }));
      }
      return list
        .filter(name => String(name).toLowerCase().includes(key))
        .map(name => ({ name }));
    },
  },
  methods: {
    teacherNameList(row) {
      return (row.TeacherNames || "")
        .split(/[、,，;；]/)
        .map((n) => (n || "").trim())
        .filter((n) => n);
    },
    openTeacherViewDialog(row) {
      if (!row) return;
      const list = this.teacherNameList(row);
      this.teacherViewDialog = {
        visible: true,
        title: `查看包含教师 - ${row.Name || '统计分组'}`,
        groupName: row.Name || '',
        teachers: list,
        filterKey: '',
      };
    },
    copyAllTeacherNames() {
      const names = (this.filteredViewTeachers || []).map(item => item.name).filter(Boolean);
      if (!names.length) {
        this.$message.warning('暂无可复制的内容');
        return;
      }
      this.copyTextToClipboard(names.join('、'));
      this.$message.success(`已复制 ${names.length} 名教师姓名`);
    },
    copySingleTeacherName(text) {
      if (!text) return;
      this.copyTextToClipboard(text);
      this.$message.success(`已复制: ${text}`);
    },
    copyTextToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).catch(() => {
          this.fallbackCopyText(text);
        });
      } else {
        this.fallbackCopyText(text);
      }
    },
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('复制失败', err);
      }
      document.body.removeChild(textArea);
    },
    deptNameList(row) {
      return (row.DepartmentNames || "")
        .split("、")
        .map((n) => (n || "").trim())
        .filter((n) => n);
    },
    // 部门树点击
    treeNodeClick(data) {
      this.departmentId = data.value;
      this.departmentName = data.label || "";
      this.page = 1;
      this.getList();
      this.loadOptions();
      this.loadLeaveApprovalConfig();
    },

    // 加载请假审批流程配置
    loadLeaveApprovalConfig() {
      if (!this.departmentId) return;
      this.leaveApprovalLoading = true;
      getLeaveApprovalConfig({ departmentId: this.departmentId })
        .then((res) => {
          if (res && res.data && res.data.success) {
            const resp = res.data.response || {};
            this.leaveApprovalConfig.autoCompleteOnApproverOverlap =
              !!resp.AutoCompleteOnApproverOverlap;
            this.leaveApprovalConfig.showMealRefund = !!resp.ShowMealRefund;
          }
        })
        .catch(() => {
          this.$message.error("加载请假审批配置失败");
        })
        .finally(() => {
          this.leaveApprovalLoading = false;
        });
    },

    // 保存请假审批流程配置
    saveLeaveApprovalConfig() {
      if (!this.departmentId) {
        this.$message.warning("请先在左侧选择部门");
        return;
      }
      this.leaveApprovalSaving = true;
      setLeaveApprovalConfig({
        departmentId: this.departmentId,
        autoCompleteOnApproverOverlap:
          !!this.leaveApprovalConfig.autoCompleteOnApproverOverlap,
        showMealRefund: !!this.leaveApprovalConfig.showMealRefund,
      })
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message.success("保存成功");
            this.loadLeaveApprovalConfig();
          } else {
            this.$message.error((res && res.data && res.data.msg) || "保存失败");
          }
        })
        .catch(() => {
          this.$message.error("保存失败，请稍后重试");
        })
        .finally(() => {
          this.leaveApprovalSaving = false;
        });
    },

    // 获取列表
    getList() {
      if (!this.departmentId) return;
      this.loading = true;
      let params = {
        departmentId: this.departmentId,
        name: this.filters.name,
        page: this.page,
        intPageSize: this.pageSize,
      };
      getLeaveStatPermissionGroupList(params)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.list = res.data.response.data || [];
            this.total = res.data.response.dataCount || 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 加载选项数据（教师和部门树）
    loadOptions() {
      // 加载教师列表
      getTeacherMasterList({ departmentId: this.departmentId }).then((res) => {
        if (res && res.data && res.data.success) {
          this.teacherOptions = res.data.response || [];
        }
      });
      // 加载部门/班级树
      getSubDepartmentTree({ pid: this.departmentId }).then((res) => {
        if (res && res.data && res.data.success) {
          this.deptTreeOptions = res.data.response || [];
        }
      });
    },

    // 弹窗处理
    handleAdd() {
      if (!this.departmentId) {
        this.$message.warning("请先在左侧选择部门");
        return;
      }
      this.dialogTitle = "新增统计权限组";
      this.editForm = {
        Id: 0,
        Name: "",
        DepartmentId: this.departmentId,
        Remark: "",
        DepartmentIds: "",
        TeacherMasterIds: "",
      };
      this.teacherIds = [];
      this.deptIds = [];
      this.dialogVisible = true;
      if (this.$refs.editForm) this.$refs.editForm.resetFields();
    },

    handleEdit(row) {
      this.dialogTitle = "编辑统计权限组";
      this.editForm = Object.assign({}, row);
      this.teacherIds = (row.TeacherMasterIds || "").split(",").filter((id) => id);
      this.deptIds = (row.DepartmentIds || "").split(",").filter((id) => id);
      this.dialogVisible = true;
    },

    handleDelete(row) {
      this.$confirm("确定要删除该权限分组吗？", "提示", {
        type: "warning",
      }).then(() => {
        deleteLeaveStatPermissionGroup({ id: row.Id }).then((res) => {
          if (res && res.data && res.data.success) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.data.msg || "删除失败");
          }
        });
      });
    },

    handleViewDepts(row) {
      this.viewRow = row;
      this.viewVisible = true;
    },

    // 提交表单
    submitForm() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.saving = true;
          // 合并ID列表
          this.editForm.TeacherMasterIds = this.teacherIds.join(",");
          this.editForm.DepartmentIds = this.deptIds.join(",");

          saveLeaveStatPermissionGroup(this.editForm)
            .then((res) => {
              this.saving = false;
              if (res && res.data && res.data.success) {
                this.$message.success("保存成功");
                this.dialogVisible = false;
                this.getList();
              } else {
                this.$message.error(res.data.msg || "保存失败");
              }
            })
            .catch(() => {
              this.saving = false;
              this.$message.error("请求失败，请稍后重试");
            });
        }
      });
    },


    // 分页处理
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
.leave-config-page.dp-layout {
  padding: 12px;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow: hidden;
}

.dp-layout {
  height: 100%;
}

.dp-left {
  overflow-y: auto;
}

.dp-right {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-height: 0;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
}

.config-panel {
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.config-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
}

.settings-card {
  flex-shrink: 0;
}

.table-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.config-card {
  border-radius: 8px;
  border: 1px solid #e8edf5;
  box-shadow: none;
  margin-bottom: 0;
}

.config-card ::v-deep .el-card__header {
  padding: 10px 14px;
  border-bottom: 1px solid #eef1f6;
}

.config-card ::v-deep .el-card__body {
  padding: 12px 14px;
}

.table-card ::v-deep .el-card__header {
  flex-shrink: 0;
}

.table-card ::v-deep .el-card__body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tbl-scroll-host {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.tbl-scroll-host ::v-deep .el-table {
  height: 100% !important;
}

.tbl-scroll-host ::v-deep .el-table__header-wrapper {
  overflow: hidden !important;
}

.tbl-scroll-host ::v-deep .el-table--scrollable-y .el-table__body-wrapper {
  overflow-x: hidden !important;
}

.tbl-scroll-host ::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}

.card-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 12px;
}

.card-header .title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  border-left: 3px solid var(--btn-primary, #2563eb);
  padding-left: 8px;
  line-height: 1.2;
}

.table-header .header-actions {
  margin-left: auto;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 200px;
}

.setting-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

.setting-tile {
  border: 1px solid #e8edf5;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px 12px;
}

.setting-tile--wide {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
}

.setting-tile--wide .tile-label {
  margin-bottom: 0;
}

.setting-tile--wide .tile-tip {
  margin: 0;
  flex: 1 1 280px;
}

.tile-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}

.tile-label i {
  margin-right: 4px;
  color: var(--btn-primary, #2563eb);
}

.tile-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tile-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.pagination-container {
  flex-shrink: 0;
  margin-top: 12px;
  text-align: right;
}

.no-department-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 0;
  background: #fff;
  border-radius: 8px;
}

/* Luxury UI 重构样式 - 轻量化表格预览 */
.empty-inline {
  color: #c0c4cc;
}

.table-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}

::v-deep td.leave-table-action-col .cell {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  padding: 6px 0;
}

::v-deep .table-actions .el-button--text {
  padding: 0 4px;
  font-size: 13px;
}

.danger-text-btn {
  color: #f56c6c;
}

.luxury-preview {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.luxury-preview:hover {
  background: #f0f7ff;
}

.tags-overflow-mask {
  display: flex;
  gap: 4px;
  overflow: hidden;
}

.glass-tag {
  background: #f0f7ff;
  color: var(--btn-primary, #2563eb);
  font-size: 11px;
  padding: 1px 8px;
  border-radius: 4px;
  border: 1px solid #d9ecff;
  white-space: nowrap;
}

.luxury-badge {
  background: #909399;
  color: #fff;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 4px;
  font-weight: 600;
  flex-shrink: 0;
  transform: scale(0.9);
}

/* Luxury 弹窗重构 */
.luxury-dialog {
  border-radius: 20px !important;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}

.luxury-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.header-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--btn-primary, #2563eb), #0055ff);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.header-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-text .prefix {
  font-size: 14px;
  color: #909399;
}

.header-text .divider {
  color: #dcdfe6;
}

.header-text .group-name {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
}

.luxury-body {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
}

.luxury-tags-wall {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.refined-tag {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  padding: 6px 14px;
  border-radius: 10px;
  font-size: 13px;
  transition: all 0.2s;
}

.refined-tag:hover {
  border-color: var(--btn-primary, #2563eb);
  color: var(--btn-primary, #2563eb);
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(64, 158, 255, 0.1);
}

.empty-state-mini {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
  font-size: 14px;
}

/* 滚动条美化 */
.luxury-body::-webkit-scrollbar {
  width: 6px;
}

.luxury-body::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}

.luxury-body::-webkit-scrollbar-thumb:hover {
  background: #cbd5e1;
}

/* 窄屏响应式优化：防止请假审批头部的标题、搜索、按钮在缩屏/移动端下重叠乱架 */
@media (max-width: 992px) {
  .leave-config-page.dp-layout {
    padding: 10px;
  }

  .table-header .header-actions {
    margin-left: 0;
    width: 100%;
  }

  .search-input {
    flex: 1;
    width: auto;
  }

  ::v-deep .el-dialog {
    width: 92% !important;
  }
  ::v-deep .el-dialog .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    margin-bottom: 16px;
  }
  ::v-deep .el-dialog .el-form-item__label {
    width: 100% !important;
    text-align: left !important;
    padding: 0 0 6px !important;
    line-height: 1.35 !important;
    font-weight: 600;
    color: #334155;
  }
  ::v-deep .el-dialog .el-form-item__content {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .tbl-scroll-host ::v-deep .el-table--scrollable-y .el-table__body-wrapper {
    overflow-x: auto !important;
  }
}

/* 请假统计配置包含教师查看按钮与弹窗。最后更新：2026-09-08 */
.kq-dept-link-btn {
  padding: 4px 10px;
  font-size: 13px;
  color: #2563eb;
  background-color: #eff6ff;
  border-radius: 4px;
  line-height: 18px;
  border: 1px solid #bfdbfe;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.kq-dept-link-btn:hover,
.kq-dept-link-btn:focus {
  color: #1d4ed8;
  background-color: #dbeafe;
  border-color: #93c5fd;
}

.kq-dept-view-dialog .el-dialog__body {
  padding: 16px 20px 10px;
}

.kq-view-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 14px;
}

.kq-view-head-item {
  font-size: 13px;
  color: #334155;
}

.kq-view-head-item .label {
  color: #64748b;
}

.kq-view-head-item .val {
  font-weight: 500;
  color: #0f172a;
}

.kq-view-head-item .count-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}

.kq-view-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.kq-view-search-input {
  max-width: 280px;
}

.kq-view-table-wrap {
  border-radius: 4px;
  overflow: hidden;
}

.kq-view-table .dept-text {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
}

.kq-view-empty {
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
}

/* 包含教师多选：完整展示标签，过多时区域内滚动。最后更新：2026-10-30 */
.stat-teacher-select ::v-deep .el-select__tags {
  max-height: 120px;
  overflow-y: auto;
}
</style>
